import(/* webpackMode: "eager" */ "/Users/zuzu/Codes/d-paleta/tanabetax.com/tanabetax-com-renew-2023/app/page.tsx")